export enum RoleType {
  SuperAdmin = 'Super Admin',
  WorkspaceAdmin = 'Workspace Admin',
  User = 'User'
}
